// const group = {
//   FACHHANDEL: 1,
//   WERBE: 2,
//   PRESSE: 3
// }

import { action, observable } from "mobx"
import customerStore from "stores/customerStore";

export default class SessionModelBase {
  
  @observable customer = false
  @observable costCentres = []
  @observable activeCostCentreId = false
  
  constructor( data, shop ) {
    this.shop = shop
    Object.assign( this, data )
    console.log( "CC NEW", data )
    const { restoreId } = customerStore
    if ( restoreId ) {
      console.log( "Set CUSTOMER FROM RESTORE TOKEN" )
      customerStore.setCustomer( restoreId )
      this.prepare()
    }
    
    this.canUseCartApi = typeof this.value === "object"
  }
  
  async prepare() {
    const customerId = this.customer.map_id || this.customer
    this.costCentres = await this.shop.fetch( `/shop/rest/costcentre/data?start=0&count=120&customer=${customerId}` )
    console.log( "CC", customerId, this.costCentres )
  }
  
  @action
  setCostCentre( costCentreId ) {
    this.activeCostCentreId = costCentreId
    this.shop.cart.data.costcentre = costCentreId
    this.shop.cart.saveImmediate()
  }
  
  @action
  setCustomer( customer ) {
    this.customer = customer
    this.prepare()
  }
  
  hasGroup( groupName ) {
    return this.group === groupName
  }
  
  hasRole( roleName ) {
    return this.shopuser && this.shopuser.roles && this.shopuser.roles.some( role => `${role}`.toUpperCase() === `${roleName}`.toUpperCase() )
  }
  
  destroy() {
    sessionStorage.clear()
  }
}



// WEBPACK FOOTER //
// ./src/theme/braunsheitmann/shop/SessionModel.js